document.addEventListener('alpine:init', () => {
  function replaceChildrenFrom(target, sourceEl) {
    if (!target || !sourceEl) return;
    if (window.Alpine && typeof Alpine.destroyTree === 'function') {
      Array.from(target.children).forEach((child) => Alpine.destroyTree(child));
    }
    target.replaceChildren(...Array.from(sourceEl.cloneNode(true).childNodes));
  }

  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      locked: null,
      _morphing: false,
      _pendingHtml: null,
      _pendingUpdates: null,
      _flushing: false,
      _liveRoot() {
        return this.$root && this.$root.isConnected
          ? this.$root
          : document.querySelector('[data-cart-items]');
      },
      async _morphItems(html, options) {
        if (!html) return;
        this._pendingHtml = html;
        this._pendingMorphOptions = options || {};
        if (this._morphing) return;
        this._morphing = true;
        try {
          while (this._pendingHtml) {
            const nextHtml = this._pendingHtml;
            const nextOptions = this._pendingMorphOptions || {};
            this._pendingHtml = null;
            this._pendingMorphOptions = {};
            this._morphItemsNow(nextHtml, nextOptions);
          }
        } finally {
          this._morphing = false;
        }
      },
      _visibleItemCount(root) {
        const el = root || this._liveRoot();
        return el ? el.querySelectorAll('.custom-cart-item:not([hidden])').length : 0;
      },
      _hasPendingWork() {
        return !!(
          this._flushing ||
          window.__sidecarCartFlushing ||
          (this._pendingUpdates && Object.keys(this._pendingUpdates).length)
        );
      },
      _setDrawerEmptyState(isEmpty) {
        const root = this._liveRoot();
        const form = root && root.querySelector('.custom-cart-items__form');
        const emptyEl = root && root.querySelector('.custom-cart-empty');
        const drawer = document.querySelector('.custom-cart-drawer');
        if (form) form.hidden = !!isEmpty;
        if (emptyEl) emptyEl.hidden = !isEmpty;
        if (drawer) drawer.classList.toggle('is-empty', !!isEmpty);
        if (isEmpty) {
          if (typeof clearSidecarBlockedGifts === 'function') clearSidecarBlockedGifts();
          if (form) {
            const host = form.querySelector('[data-cart-upsell-host]');
            if (host) host.replaceChildren();
          }
          if (window.Alpine && Alpine.store('cart_count')) {
            Alpine.store('cart_count').count = 0;
            if (Alpine.store('cart_count').setPending) Alpine.store('cart_count').setPending(false);
          }
        }
      },
      _recoverDrawerIfBlank() {
        if (this._hasPendingWork()) return;
        const visible = this._visibleItemCount();
        if (visible > 0) {
          this._setDrawerEmptyState(false);
          return;
        }
        this._setDrawerEmptyState(true);
      },
      _morphItemsNow(html, options) {
        const incoming = querySelectorInHTMLString('[data-cart-items]', html);
        const root = this._liveRoot();
        if (!incoming || !root) return;
        if (!options || options.preserveAutoGifts !== true) {
          stripBlockedGiftsFromTree(incoming);
        }
        if (typeof stripRemovedPaidFromTree === 'function') stripRemovedPaidFromTree(incoming);
        this.itemsRoot = root;

        const incomingForm = incoming.querySelector('.custom-cart-items__form');
        const currentForm = root.querySelector('.custom-cart-items__form');
        const incomingList = incoming.querySelector('[data-cart-item-list], .custom-cart-items__list');
        const currentList = root.querySelector('[data-cart-item-list], .custom-cart-items__list');
        const incomingHasItems = !!incoming.querySelector('li[key]:not([hidden]), .custom-cart-item:not([hidden])');
        const addPending = !!(window.Alpine && Alpine.store('cart_count') && Alpine.store('cart_count').pending);

        if (!incomingHasItems && (addPending || this._hasPendingWork() || this._visibleItemCount(root) > 0)) {
          return;
        }

        if (incomingForm && currentForm && incomingList && currentList) {
          replaceChildrenFrom(currentList, incomingList);
          if (!options || options.replaceUpsell !== false) {
            const currentHost = currentForm.querySelector('[data-cart-upsell-host]');
            const incomingHost = incomingForm.querySelector('[data-cart-upsell-host]');
            if (currentHost && incomingHost) {
              currentHost.replaceWith(incomingHost.cloneNode(true));
            } else if (incomingHost && !currentHost) {
              currentForm.appendChild(incomingHost.cloneNode(true));
            } else if (currentHost && !incomingHost) {
              currentHost.remove();
            }
          }
          this._setDrawerEmptyState(!incomingHasItems);
        } else if (!incomingHasItems) {
          this._setDrawerEmptyState(true);
        } else {
          replaceChildrenFrom(root, incoming);
          this._setDrawerEmptyState(false);
        }

        root.querySelectorAll('.is-leaving, .is-updating, .opacity-50, .cursor-progress').forEach((el) => {
          el.classList.remove('is-leaving', 'is-updating', 'opacity-50', 'cursor-progress', 'is-entering', 'is-entered');
          el.style.maxHeight = '';
          el.style.transform = '';
        });
      },
      init() {
        this.itemsRoot = this.$root;

        this._onAfterAdd = async (e) => {
          if (typeof clearSidecarPaidRemoved === 'function') clearSidecarPaidRemoved();
          const data = e.detail && e.detail.response;
          const existingHtml = data && data.sections ? data.sections['cart-items'] : null;
          const morphOptions = { preserveAutoGifts: true };
          if (isSidecarCartHtml(existingHtml)) {
            if (e.detail && e.detail.epoch != null && !isCurrentSidecarCartEpoch(e.detail.epoch)) return;
            this._morphItems(existingHtml, morphOptions);
          } else if (e.detail && e.detail.epoch != null) {
            if (!isCurrentSidecarCartEpoch(e.detail.epoch)) return;
            this._morphItems(existingHtml, morphOptions);
          } else {
            const epochAtStart = window.__sidecarCartEpoch || 0;
            const fresh = await fetchSidecarCartSections({ force: true });
            if ((window.__sidecarCartEpoch || 0) !== epochAtStart) return;
            if (fresh && data) data.sections = Object.assign({}, data.sections || {}, fresh);
            const html = (fresh && fresh['cart-items']) || existingHtml;
            this._morphItems(html, morphOptions);
          }
          if (typeof reconcileSidecarCartWithAjax === 'function') {
            await reconcileSidecarCartWithAjax();
          }
        };

        this._onQtyChange = async (e) => {
          const epoch = e.detail && e.detail.epoch != null
            ? e.detail.epoch
            : nextSidecarCartEpoch();
          const data = e.detail && e.detail.response;
          await ensureSidecarCartSections(data);
          if (!isCurrentSidecarCartEpoch(epoch)) return;
          const sections = data && data.sections;
          if (!sections || !sections['cart-items']) return;
          await this._morphItems(sections['cart-items'], {
            replaceUpsell: false,
            preserveAutoGifts: !!(e.detail && e.detail.preserveAutoGifts),
          });

          this.$nextTick(() => {
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          if (sections['cart-live-region']) {
            const liveRegion = parseDOMFromString(sections['cart-live-region']).firstElementChild;
            const cartStatus = document.getElementById('cart-live-region-text');
            if (liveRegion && cartStatus) {
              cartStatus.textContent = liveRegion.textContent;
              cartStatus.setAttribute('aria-hidden', false);
            }
          }

          const closeButton = document.querySelector('.custom-cart-drawer__close');
          if (closeButton && e.detail.originalTarget && this.itemsRoot && !this.itemsRoot.contains(e.detail.originalTarget)) {
            closeButton.focus({ preventScroll: true });
          }
        };

        window.addEventListener('shapes:modalcart:afteradditem', this._onAfterAdd);
        window.addEventListener('shapes:modalcart:cartqtychange', this._onQtyChange);

        this._onQtyClick = (event) => {
          const button = event.target.closest('[data-qty-step]');
          if (!button || !this.$root.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          if (event.timeStamp && this._lastQtyStamp === event.timeStamp) return;
          this._lastQtyStamp = event.timeStamp;
          const delta = parseInt(button.getAttribute('data-qty-step'), 10);
          if (!delta) return;
          this._stepQty(delta, button.closest('li[key]'));
        };
        this.$root.addEventListener('click', this._onQtyClick);
      },
      destroy() {
        window.removeEventListener('shapes:modalcart:afteradditem', this._onAfterAdd);
        window.removeEventListener('shapes:modalcart:cartqtychange', this._onQtyChange);
        if (this.$root && this._onQtyClick) {
          this.$root.removeEventListener('click', this._onQtyClick);
        }
      },
      _isGiftLine(lineItemEl) {
        return !!(
          lineItemEl &&
          (lineItemEl.getAttribute('data-sidecar-gift') === 'true' ||
            lineItemEl.querySelector('.custom-cart-item__price--free'))
        );
      },
      _queueDependentGiftRemovals(removedPaidEl) {
        const root = this._liveRoot();
        if (!root) return;
        const paidStillInCart = Array.from(root.querySelectorAll('li[key]')).some((li) => {
          if (li === removedPaidEl || li.hidden) return false;
          return !this._isGiftLine(li);
        });
        if (paidStillInCart) {
          this._queuePredictedGiftRemovals(removedPaidEl, root);
          return;
        }
        if (typeof markSidecarPaidRemoved === 'function') {
          markSidecarPaidRemoved(removedPaidEl && removedPaidEl.getAttribute('key'));
        }
        this._pendingPaidCascade = true;
        root.querySelectorAll('li[key]').forEach((li) => {
          if (li === removedPaidEl || !this._isGiftLine(li)) return;
          const key = li.getAttribute('key');
          if (!key) return;
          li.hidden = true;
          li.setAttribute('data-sidecar-pending-remove', '');
          this._pendingUpdates[key] = 0;
        });
      },
      // Another paid item is staying, so we can't tell from the DOM whether the gifts
      // survive -- it may be a trigger itself. AddMate can tell us, and folding its
      // answer into this same flush keeps the removal to one request and one render
      // instead of letting its cleanup pass take the gifts a beat later. Anything it
      // won't vouch for is left to that cleanup pass, so nothing gets hidden on a guess.
      _queuePredictedGiftRemovals(removedPaidEl, root) {
        const removedKey = removedPaidEl && removedPaidEl.getAttribute('key');
        if (!removedKey || typeof window.__addmatePredictIneligibleGiftLineKeys !== 'function') return;
        let doomedKeys = null;
        try {
          doomedKeys = window.__addmatePredictIneligibleGiftLineKeys([removedKey]);
        } catch (e) {
          return;
        }
        if (!Array.isArray(doomedKeys) || doomedKeys.length === 0) return;
        const doomed = new Set(doomedKeys.map(String));
        root.querySelectorAll('li[key]').forEach((li) => {
          const key = li.getAttribute('key');
          if (!key || !doomed.has(String(key)) || !this._isGiftLine(li)) return;
          li.hidden = true;
          li.setAttribute('data-sidecar-pending-remove', '');
          this._pendingUpdates[key] = 0;
        });
      },
      _queueUpdate(id, quantity, lineItemEl) {
        if (!id) return;
        this._pendingUpdates = this._pendingUpdates || {};
        this._pendingUpdates[id] = quantity;
        if (quantity === 0 && lineItemEl) {
          lineItemEl.hidden = true;
          lineItemEl.setAttribute('data-sidecar-pending-remove', '');
          if (this._isGiftLine(lineItemEl)) {
            recordSidecarGiftDismissals(id, lineItemEl);
          } else {
            this._queueDependentGiftRemovals(lineItemEl);
          }
        }
        nextSidecarCartEpoch();
        this._flushUpdates();
      },
      _restorePendingRemoves() {
        const root = this._liveRoot();
        if (!root) return;
        root.querySelectorAll('[data-sidecar-pending-remove]').forEach((el) => {
          if (this._isGiftLine(el) && typeof isSidecarGiftBlocked === 'function') {
            const key = el.getAttribute('key');
            const handle = el.getAttribute('data-product-handle');
            const variant = el.getAttribute('data-gift-variant');
            if (isSidecarGiftBlocked(key, handle, variant)) return;
          }
          el.hidden = false;
          el.removeAttribute('data-sidecar-pending-remove');
        });
      },
      async _flushUpdates() {
        if (this._flushing) return;
        this._flushing = true;
        window.__sidecarCartFlushing = true;
        try {
          while (this._pendingUpdates && Object.keys(this._pendingUpdates).length) {
            const updates = this._pendingUpdates;
            this._pendingUpdates = {};
            const epoch = window.__sidecarCartEpoch || nextSidecarCartEpoch();
            const keys = Object.keys(updates);
            const lineItemEl = this._liveRoot() && this._liveRoot().querySelector(`li[key="${keys[0]}"]`);
            let data = {};
            try {
              const config = fetchConfigDefaults();
              config.body = JSON.stringify({
                updates,
                sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
                sections_url: cartSectionsUrl(),
              });
              const res = await fetch(withPreviewTheme(theme.routes.cart_update_url || theme.routes.cart_change_url), config);
              data = await res.json();
              if (!isCurrentSidecarCartEpoch(epoch)) continue;
              if (data && data.status && keys.length === 1) {
                this._restorePendingRemoves();
                continue;
              }
              if (this._pendingPaidCascade && typeof sweepSidecarGiftOnlyCart === 'function') {
                await sweepSidecarGiftOnlyCart();
                this._pendingPaidCascade = false;
              }
              if (!isSidecarCartHtml((data.sections && data.sections['cart-items']) || '')) {
                const fresh = await fetchSidecarCartSections({ force: true });
                if (fresh) data.sections = Object.assign({}, data.sections || {}, fresh);
              }
              if (!isCurrentSidecarCartEpoch(epoch)) continue;
              if (this._pendingUpdates && Object.keys(this._pendingUpdates).length) continue;
              if (data && data.sections && data.sections['cart-items']) {
                document.body.dispatchEvent(
                  new CustomEvent('shapes:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl, epoch },
                  })
                );
              }
            } catch (e) {
              if (isCurrentSidecarCartEpoch(epoch)) {
                this._restorePendingRemoves();
                const errors = document.getElementById('cart-errors');
                if (errors) errors.textContent = theme.strings.cartError;
              }
            }
          }
        } finally {
          this._flushing = false;
          window.__sidecarCartFlushing = !!(this._pendingUpdates && Object.keys(this._pendingUpdates).length);
          if (this._pendingUpdates && Object.keys(this._pendingUpdates).length) {
            this._flushUpdates();
          } else {
            this._recoverDrawerIfBlank();
          }
        }
      },
      itemQuantityChange(key, value) {
        const lineItemEl = this.$el.closest('li[key]');
        const id = key ? key : lineItemEl && lineItemEl.getAttribute('key');
        const quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10);
        const lastValue = parseInt(this.$el.dataset.lastValue, 10);
        if (!id || quantity === lastValue) return;
        this.$el.dataset.lastValue = String(quantity);
        this._queueUpdate(id, quantity, lineItemEl);
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');

        const currentValue = parseInt(inputEl.value, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = currentValue + 1;
        }

        if (operation == 'decrement') {
          if (currentValue > 1) {
            newValue = currentValue - 1;
          } else {
            newValue = 1;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        const quantityDisplay = el
          .closest('li[key]')
          .querySelector('[data-quantity-display]');

        if (quantityDisplay) {
          quantityDisplay.textContent = newValue;
        }

        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
      },
      _lineQuantity(lineItemEl) {
        const id = lineItemEl && lineItemEl.getAttribute('key');
        if (id && this._pendingUpdates && this._pendingUpdates[id] != null) {
          return this._pendingUpdates[id];
        }
        const inputEl = lineItemEl && lineItemEl.querySelector('input[type="number"]');
        return parseInt(inputEl && inputEl.value, 10) || 0;
      },
      _stepQty(delta, lineItemEl) {
        if (!lineItemEl) return;
        const next = delta < 0
          ? Math.max(1, this._lineQuantity(lineItemEl) + delta)
          : this._lineQuantity(lineItemEl) + delta;
        const inputEl = lineItemEl.querySelector('input[type="number"]');
        if (inputEl) {
          inputEl.value = next;
          inputEl.dataset.lastValue = String(next);
        }
        const quantityDisplay = lineItemEl.querySelector('[data-quantity-display]');
        if (quantityDisplay) quantityDisplay.textContent = String(next);
        this._queueUpdate(lineItemEl.getAttribute('key'), next, lineItemEl);
      },
      increment() {
        this._stepQty(1);
      },
      decrement() {
        this._stepQty(-1);
      },
      remove() {
        const lineItemEl = this.$el.closest('li[key]');
        if (!lineItemEl) return;
        const inputEl = lineItemEl.querySelector('input[type="number"]');
        if (inputEl) {
          inputEl.value = 0;
          inputEl.dataset.lastValue = '0';
        }
        this._queueUpdate(lineItemEl.getAttribute('key'), 0, lineItemEl);
      },
    };
  });
});
